import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';

import {
  MatCalendar,
} from '@angular/material/datepicker';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { SwapWifiService } from 'src/app/services/swap-wifi.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PullUpSwapWifiComponent } from '../pull-up-swap-wifi/pull-up-swap-wifi.component';
import { ConfirmDialogService } from '../swap-wifi-shared-module/confirm-dialog/confirm-dialog.service';
import { ContractInfo } from 'src/app/_interface/contract-info';
import { TransactionInfo } from 'src/app/_interface/transaction-info';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentsService } from 'src/app/services/enviroment.service';
import { deleteCookie, setCookie } from 'src/app/services/cookies';
const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'MMMM YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-swap-wifi',
  templateUrl: './swap-wifi.component.html',
  styleUrls: ['./swap-wifi.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    { provide: MAT_DATE_LOCALE, useValue: 'vi-VN' },

    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class SwapWifi6Component implements OnInit {
  transId: any;
  utmSource: any;
  locationId: any;
  utmExtraBranchcode: any;
  utmExtraMac: any;
  constructor(
    public swapWifiService: SwapWifiService,
    readonly modalService: NgbModal,
    readonly confirm: ConfirmDialogService,
    readonly spinner: NgxSpinnerService,
    readonly route: ActivatedRoute,
    public env: EnvironmentsService
  ) {
    this.route.queryParams.subscribe((params: any) => {
      this.utmSource = params['utm_source'];
      this.contractNo = params['contractNo'];
      this.transId = params['trans_id'];
      this.phoneNumber = params['phone_nb'];
      this.locationId = params['locationid'];
      this.utmExtraBranchcode = params['utm_extra_branchcode'];
      this.utmExtraMac = params['utm_extra_mac'];
      deleteCookie('contractNo');
      deleteCookie('phoneNumber');
    });
  }
  phoneNumber: any;
  contractNo: any;
  maxDate: any = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate() + 30
  );
  minDate: any = new Date();
  selectedDate: any;
  timeInstallation: any;
  exampleHeader = ExampleHeader;
  contractInfo: ContractInfo = {};
  transactionInfo: TransactionInfo = {};
  paymentMethod: any;
  selectedMethod: any;
  listTime: Array<any> = [];
  showTooltip: boolean = false;
  showDatePicker: boolean = false;
  showMethod: boolean = false;
  selectedTime: any;
  apointmentTime: any;
  infoSubscription: any;
  apointmentSubscription: any;
  paymentSubscription: any;
  dateApointment: any;
  firstTime: any;
  paymentInfo: any;
  firstActiveTime: any;
  readonly getInfoSubject = new Subject();
  readonly getApointmentTimeSubject = new Subject();
  readonly paymentSubject = new Subject();
  ngOnInit(): void {
    this.infoSubscription = this.getInfoSubject
      .pipe(
        switchMap(() =>
          this.swapWifiService.getInfo('6', {
            utm_source: this.utmSource,
            location_id: this.locationId ? this.locationId : undefined,
            branch_code: this.utmExtraBranchcode ? this.utmExtraBranchcode : undefined,
            mac: this.utmExtraMac ? this.utmExtraMac : undefined,
            contract_no: this.contractNo,
            phone_nb: this.phoneNumber,
            trans_id: this.transId ? parseInt(this.transId) : undefined,
          })
        )
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res && res.status === 1) {
            this.contractInfo = res.detail.contract_info;
            this.transactionInfo = res.detail.transaction_info;
            this.paymentMethod = res.detail.payment_method;
            if(this.paymentMethod.length > 0) {
              this.selectedMethod = res.detail.payment_method.find(
                (item: any) => item.is_selected
              );
              this.selectedMethod = !this.selectedMethod ?  res.detail.payment_method[0] : this.selectedMethod;
            }
            this.timeInstallation = res.detail.time_installation;
            this.paymentInfo = res.detail.payment_detail;
            sessionStorage.setItem(
              'paymentInfo',
              JSON.stringify(this.paymentInfo)
            );

            if (this.timeInstallation.is_warning) {
              this.selectedDate = new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate() + 4
              );
              this.dateApointment = this.swapWifiService.convertDateToDDMMYYYY(
                this.selectedDate
              );
            } else {
              let dateArr = this.timeInstallation.date.split('/');
              let date = dateArr[2] + '/' + dateArr[1] + '/' + dateArr[0];
              this.selectedDate = new Date(date);

              this.dateApointment = this.swapWifiService.convertDateToDDMMYYYY(
                this.selectedDate
              );
              this.selectedTime = this.timeInstallation;
            }
          } else {
            //Hiện popup
            this.confirm.confirm(
              'Thông báo',
              res.msg,
              'Đã hiểu',
              undefined,
              'justify-content-end'
            );
          }
        },
        (errors: any) => {
          this.spinner.hide();
        }
      );
    this.getInfoSubject.next(1);
    this.spinner.show();
    this.apointmentSubscription = this.getApointmentTimeSubject
      .pipe(switchMap((date) => this.swapWifiService.getAppointmentTime('6', date)))
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res && res.status === 1) {
            this.listTime = res.detail.list_time_slot;
            this.apointmentTime = this.firstActiveTime = this.listTime.find(
              (element) => element.is_available
            );
            this.firstTime = this.firstActiveTime
              ? this.firstActiveTime.time_slot
              : undefined;
            this.showDatePicker = true;
          } else {
            //Hiện popup
            this.confirm.confirm(
              'Thông báo',
              res.msg,
              'Đồng ý',
              undefined,
              'justify-content-end'
            );
          }
        },
        (errors: any) => {
          this.spinner.hide();
        }
      );
    this.paymentSubscription = this.paymentSubject
      .pipe(
        switchMap((paymentInfo) => this.swapWifiService.payment('6', paymentInfo))
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res && res.status === 1) {
            if (res.detail.is_redirect === 1) {
              setCookie("contractNo", encodeURIComponent(this.contractNo), 5);
              setCookie("phoneNumber", encodeURIComponent(this.phoneNumber), 5);
              window.location.href = res.detail.redirect_url;
            } else {
              const a = document.querySelector('.swap-wifi-comp-wrapper');

              if (a) {
                this.getInfoSubject.next(1);
                a.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }
          } else {
            //Hiện popup
            this.confirm.confirm(
              'Thông báo',
              res.msg,
              'Đóng',
              undefined,
              'justify-content-end'
            );
          }
        },
        (errors: any) => {
          this.spinner.hide();
        }
      );
  }
  toggleDatePicker(date: any) {
    if (!this.showDatePicker) {
      this.spinner.show();
      this.getApointmentTimeSubject.next({
        appointment_date: date,
        utm_source: this.utmSource,
        contract_no: this.contractNo,
        phone_nb: this.phoneNumber,
        location_id: this.locationId ? this.locationId : undefined,
        branch_code: this.utmExtraBranchcode ? this.utmExtraBranchcode : undefined,
        mac: this.utmExtraMac ? this.utmExtraMac : undefined,
      });
    } else {
      this.showDatePicker = false;
      this.apointmentSubscription.unsubscribe();
    }
  }

  handleSelectDateTime() {
    this.showDatePicker = false;
    this.selectedTime = this.apointmentTime
      ? this.apointmentTime
      : this.timeInstallation;
  }
  toggleTooltipPayment() {
    this.showTooltip = !this.showTooltip;
  }
  onSelectDate(e: any) {
    this.spinner.show();
    this.getApointmentTimeSubject.next({
      appointment_date: this.swapWifiService.convertMatAngularValueToDate(e),
      utm_source: this.utmSource,
      contract_no: this.contractNo,
      phone_nb: this.phoneNumber,
      location_id: this.locationId ? this.locationId : undefined,
      branch_code: this.utmExtraBranchcode ? this.utmExtraBranchcode : undefined,
      mac: this.utmExtraMac ? this.utmExtraMac : undefined,
    });
  }
  openPopup(type: any, data?: any) {
    const modalRef = this.modalService.open(PullUpSwapWifiComponent, {
      windowClass: 'pull-up-swap-wifi',
    });
    modalRef.componentInstance.typePopup = type;
    modalRef.componentInstance.dataPopup = data;
    modalRef.componentInstance.version = '6';
    modalRef.componentInstance.modalEvent.subscribe((res: any) => {
      if (res) {
        this.selectedTime = res;
        console.log(this.selectedTime);
      }
      return modalRef.result;
    });
  }
  onClickOutside(e: any) {
    this.showDatePicker = false;
  }
  toggleMethod() {
    this.showMethod = !this.showMethod;
  }

  closeMethod() {
    this.showMethod = false;
  }

  selectNewMethod(item: any, event: Event) {
    event.stopPropagation();
    this.selectedMethod = item;
    setTimeout(() => {
      this.showMethod = false;
    }, 0);
  }

  submitPayment() {
    this.confirm
      .confirm(
        'Xác nhận giao dịch',
        `<p>Quý khách vui lòng chọn “Đồng ý” để xác nhận thực hiện giao dịch.</p>`,
        'Đồng ý ',
        'Hủy bỏ'
      )
      .then((confirm) => {
        if (confirm) {
          this.spinner.show();
          this.paymentSubject.next({
            additional_money: this.paymentInfo?.addition_price,
            appointment_date: this.selectedTime.date,
            conversion_fee: this.paymentInfo?.exchange_price + this.paymentInfo?.box_fee,
            payment_method: this.selectedMethod.method_code,
            time_slot: this.selectedTime.time_slot,
            total_amount: this.paymentInfo.total_price,
            utm_source: this.utmSource,
            contract_no: this.contractNo,
            phone_nb: this.phoneNumber,
            location_id: this.locationId ? this.locationId : undefined,
            branch_code: this.utmExtraBranchcode ? this.utmExtraBranchcode : undefined,
            mac: this.utmExtraMac ? this.utmExtraMac : undefined,
          });
        }
      });
  }
  ngOnDestroy(): void {
    this.infoSubscription.unsubscribe();
    this.apointmentSubscription.unsubscribe();
    this.paymentSubscription.unsubscribe();
  }
}

@Component({
  selector: 'example-header',
  styles: [],
  template: `
    <div
      class="example-header d-flex align-items-center justify-content-between"
    >
      <button mat-icon-button (click)="previousClicked('month')">
        <img
          src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/left-arrow.svg"
          alt=""
          width="auto"
          height="auto"
        />
      </button>
      <div class="content-label">
        <div class="month ">
          <span class="example-header-label">{{
            periodLabel.toLowerCase()
          }}</span>
        </div>
        <div class="year">
          <span class="example-header-label">{{ periodYearLabel }}</span>
        </div>
      </div>

      <button mat-icon-button (click)="nextClicked('month')">
        <img
          src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/right-arrow.svg"
          alt=""
          width="auto"
          height="auto"
        />
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExampleHeader<D> implements OnDestroy {
  readonly _destroyed = new Subject<void>();

  constructor(
    readonly _calendar: MatCalendar<D>,
    readonly _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) readonly _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef
  ) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => cdr.markForCheck());
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  get periodLabel() {
    let labelArr1 = this._dateAdapter
      .format(
        this._calendar.activeDate,
        this._dateFormats.display.monthYearLabel
      )
      .toLocaleUpperCase();
    return labelArr1.split(' ')[0] + ' ' + labelArr1.split(' ')[1];
  }

  get periodYearLabel() {
    let labelArr = this._dateAdapter
      .format(
        this._calendar.activeDate,
        this._dateFormats.display.monthYearLabel
      )
      .toLocaleUpperCase();
    return labelArr.split(' ')[2];
  }

  previousClicked(mode: 'month' | 'year') {
    this._calendar.activeDate =
      mode === 'month'
        ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1)
        : this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
  }

  nextClicked(mode: 'month' | 'year') {
    this._calendar.activeDate =
      mode === 'month'
        ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1)
        : this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
  }
}
